var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-only',{staticClass:"wallet-layout"},[_c('WalletAccount'),_c('WalletHeader',{staticClass:"mt-3"}),_c('WalletTabBar',{staticClass:"mt-3"}),_c('div',{staticClass:"mt-3"},[_c('nuxt-child')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }